import { BaseModel } from "model/BaseModel";
import Modulo from "./Modulo";

export default class Conta implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    timezone: string;
    modulos: Array<Modulo>;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        timezone = 'America/Sao_Paulo',
        modulos = new Array<Modulo>(),
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.timezone = timezone;
        this.modulos = modulos;
    }
}
